import { createGlobalStyle } from 'styled-components'

import { fontInterBold } from './fonts/inter-bold'
import { fontInterMedium } from './fonts/inter-medium'
import { fontInterRegular } from './fonts/inter-regular'
import { fontInterSemiBold } from './fonts/inter-semibold'

export { WebviewNativeStyles } from './webview-native-styles'

export const PreProcessedFontStyles = createGlobalStyle`
  @font-face {
    font-family: 'Inter';
    src: url('data:font/woff2;base64,${fontInterRegular}') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('data:font/woff2;base64,${fontInterMedium}') format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('data:font/woff2;base64,${fontInterSemiBold}') format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('data:font/woff2;base64,${fontInterBold}') format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
`
